import { Component, OnInit, Input } from '@angular/core';
import { HeatingSystem } from '../../model/interfaces';
import { CvdsUtilsService } from '../../service';
import { HeatingSystemLayout } from '../../model/layout';

@Component({
	selector: 'cv-cvds-heating-system',
	templateUrl: './cvds-heating-system.component.html',
	styleUrls: ['../../cvds-structures.component.scss']
})
export class CvdsHeatingSystemComponent implements OnInit {
	@Input() heating: HeatingSystem;
	@Input() index: number;

	constructor(private utilsService: CvdsUtilsService) {}

	fieldsModel = [];
	fieldsSections = [];

	async ngOnInit(): Promise<void> {
		const layout = new HeatingSystemLayout();
		this.fieldsModel = this.utilsService.mapFields(this.heating, layout.fields);

		layout.fieldsArray.forEach(item => {
			const { fieldName, label, fields } = item;
			if (Object.prototype.hasOwnProperty.call(this.heating, fieldName)) {
				this.fieldsSections.push({
					items: this.heating[fieldName],
					fields: fields,
					title: label
				});
			}
		});
	}
}
